import { Box, Stack, TextField } from "@mui/material";
import { useEffect } from "react";

import { ViewLayout } from "@/App/Layouts/ViewLayout";
import AppButton from "@/common/components/Button/AppButton";
import BlockCode from "@/common/components/Code/BlockCode";
import BooleanValue from "@/common/components/Form/Display/BooleanValue";
import AppLink from "@/common/components/Link/AppLink";
import AppTypography from "@/common/components/Text/AppTypography";
import { ROUTE_PATH } from "@/common/constants/routing";
import { useOnboardingContextOptional } from "@/common/contexts/onboarding";
import { useAuth0User } from "@/common/hooks/auth/useAuth0User";
import { useTenantProfile } from "@/common/hooks/entity/tenant/useTenantProfile";
import { useUserProfile } from "@/common/hooks/user/useUserProfile";
import { apiClient } from "@/core/api/ApiClient";

import SimpleViewPageHeader from "../Layouts/PageHeader/SimpleViewPageHeader";
import ViewContentBlock from "../Layouts/ViewContentBlock";
import { AppAreasRouteCategoryIndex } from "./components/AppAreasRouteCategoryIndex";

export function DevDashboard() {
  const tenantProfile = useTenantProfile();
  const auth0User = useAuth0User();
  const profile = useUserProfile();
  const onboardingContext = useOnboardingContextOptional();

  // const profileRequest = useApiRequest(apiClient.profileApi.apiV1ProfileGet, {
  //   nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
  // });
  // const profile = useMemo(() => profileRequest.data, [profileRequest.data]);

  useEffect(() => {
    onboardingContext?.fetch();
  }, []);

  return (
    <ViewLayout header={<SimpleViewPageHeader title='Dev dashboard' />}>
      <ViewContentBlock>
        <AppTypography sx={{ mb: 2 }} variant='h4'>
          App areas
        </AppTypography>

        <AppAreasRouteCategoryIndex />
      </ViewContentBlock>

      <ViewContentBlock>
        <AppTypography sx={{ mb: 2 }} variant='h4'>
          Styleguide
        </AppTypography>

        <Box>
          <AppLink to={ROUTE_PATH.DEV_STYLEGUIDE}>Styleguide</AppLink>
        </Box>
      </ViewContentBlock>

      <ViewContentBlock>
        <AppTypography sx={{ mb: 2 }} variant='h4'>
          Tenant & user info
        </AppTypography>

        <Stack direction='column' spacing={0}>
          <TextField
            disabled
            fullWidth
            label='User id'
            margin='dense'
            type='text'
            value={profile?.id || ""}
            variant='outlined'
          />
          <TextField
            disabled
            fullWidth
            label='Auth0 user id'
            margin='dense'
            type='text'
            value={auth0User?.sub || ""}
            variant='outlined'
          />
          <TextField
            disabled
            fullWidth
            label='Tenant id'
            margin='dense'
            type='text'
            value={tenantProfile?.id || ""}
            variant='outlined'
          />
          <TextField
            disabled
            fullWidth
            label='Tenant identifier'
            margin='dense'
            type='text'
            value={tenantProfile?.identifier || ""}
            variant='outlined'
          />
        </Stack>
      </ViewContentBlock>

      <ViewContentBlock>
        <AppTypography sx={{ mb: 2 }} variant='h4'>
          Onboarding
        </AppTypography>

        <Stack gap={1}>
          <Box>
            Current user has onboarding: <BooleanValue value={!!onboardingContext?.onboarding} />{" "}
            {onboardingContext?.onboarding && <>#{onboardingContext?.onboarding.id}</>}
          </Box>

          <Box>
            <AppButton
              variant='contained'
              color='primary'
              // disabled={!!onboardingContext?.onboarding}
              onClick={async () => {
                const response =
                  await apiClient.devApi.apiV1DevOnboardingGetOrCreateForCurrentUserPost({
                    nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
                  });
                onboardingContext?.set(response.data || null);
              }}
            >
              Get or create onboarding for current user (dev and test only)
            </AppButton>
          </Box>

          {onboardingContext?.onboarding && (
            <BlockCode sx={{ maxHeight: 300 }}>
              {JSON.stringify(onboardingContext?.onboarding, null, 2)}
            </BlockCode>
          )}
        </Stack>
      </ViewContentBlock>
    </ViewLayout>
  );
}
